/* eslint-disable default-param-last */
export const findItemByValue = (value, options = []) => {
  const item = options.find(m => m.value === value)
  if (item) return item
  // eslint-disable-next-line no-shadow
  for (const item of options) {
    const sonItem = findItemByValue(value, item.children)
    if (sonItem) return sonItem
  }
}
export const findItemsByValues = (value = [], options = [], data) => {
  const all = data || []
  const items = options.filter(m => value.includes(m.value))
  all.push(...items)
  for (const item of options) {
    findItemsByValues(value, item.children, all)
  }
  return all
}
